module.exports = __webpack_public_path__ + "static/media/battery-half.6542901d.svg";